
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  --cover-size:40px;
  --cover-fade:30%;
  --cover-color:#fff;
  --shadow-size:12px;
  --shadow-intensity:40%;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-normal);
  color: var(--blue-responsible-darken-1);
}

th {
  background-color: var(--cyan-near-main);
  text-align: left;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--fw-semibold);
  color: var(--neutral-white);
}

th a {
  display: flex;
}

th a {
  align-items: center;
}

th a {
  color: var(--outline-white);
}

th a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

th a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

th a .tablesort {
  margin-left: 1.25rem;
}

th a .tablesort {
  height: 1.25rem;
}

th a .tablesort {
  width: 1.25rem;
}

th a .tablesort {
  background-repeat: no-repeat;
}

th a .tablesort{
      background:url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 19V5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12L12 5L19 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      background-position:center;
    }

th a .tablesort.tablesort--desc{
        transform:rotate(180deg);
      }

th a .tablesort .visually-hidden {
  visibility: hidden;
}

tbody tr {
  border-bottom-width: 1px;
  border-top-width: 0px;
  border-right-width: 0px;
  border-left-width: 0px;
  border-style: solid;
  border-color: var(--gray-professional-lighten-3);
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

tbody tr:nth-child(odd) {
  background-color: var(--neutral-white);
}

tbody tr:nth-child(even) {
  background-color: var(--neutral-grayLight);
}

tbody td a {
  font-weight: var(--fw-semibold);
}

tbody td a {
  color: var(--blue-responsible-main);
}

tbody td a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

tbody td a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.table-wrapper {
  overflow-x: auto;
  background:linear-gradient(
      to right,
      var(--cover-color) var(--cover-fade),
      rgba(255, 255, 255, 0)
    ), linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        var(--cover-color) calc(100% - var(--cover-fade))
      ) 100% 0, radial-gradient(
        farthest-side at 0 50%,
        rgba(0, 0, 0, var(--shadow-intensity)),
        rgba(0, 0, 0, 0)
      ), radial-gradient(
        farthest-side at 100% 50%,
        rgba(0, 0, 0, var(--shadow-intensity)),
        rgba(0, 0, 0, 0)
      ) 100% 0;
  background-repeat:no-repeat;
  background-size:var(--cover-size) 100%, var(--cover-size) 100%,
    var(--shadow-size) 100%, var(--shadow-size) 100%;
  background-attachment:local, local, scroll, scroll;
  overflow:auto;
  -ms-overflow-style:none;
  scrollbar-width:none;
}

.table-wrapper--sticky table {
  min-width: 1440px;
}

.table-wrapper--sticky th:first-child, .table-wrapper--sticky td:first-child {
  position: sticky;
}

.table-wrapper--sticky th:first-child, .table-wrapper--sticky td:first-child {
  left: 0px;
}

@media screen and (max-width: 1440px){
      .table-wrapper--sticky th:first-child::after, .table-wrapper--sticky td:first-child::after{
        content:'';
        position:absolute;
        top:0;
        right:-1px;
        width:1px;
        height:100%;
        background-color:var(--cyan-near-main);
      }
    }

.table-wrapper--sticky tbody tr:nth-child(odd) th:first-child, .table-wrapper--sticky tbody tr:nth-child(odd) td:first-child {
  background-color: var(--neutral-white);
}

.table-wrapper--sticky tbody tr:nth-child(even) th:first-child, .table-wrapper--sticky tbody tr:nth-child(even) td:first-child {
  background-color: var(--neutral-grayLight);
}

.table-wrapper--sticky thead th:first-child::after{
      background-color:var(--cyan-near-darken-2);
    }
`;